import React from 'react';
import { Card, CardContent, CardActions, Skeleton, Box } from '@mui/material';
import { skeletonBg } from './skeletonStyles';

// Skeleton subscription card for SubscriptionsPage (999.2127). Mirrors the
// loaded full-width Card: name + status chip row, two detail lines, action
// buttons — so nothing jumps when subscriptions arrive.
export default function SubscriptionCardSkeleton() {
  return (
    <Card data-testid="subscription-card-skeleton">
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Skeleton variant="text" width="30%" height={32} sx={skeletonBg} />
          <Skeleton variant="rectangular" width={72} height={24} sx={[skeletonBg, { borderRadius: '12px' }]} />
        </Box>
        <Skeleton variant="text" width="45%" sx={skeletonBg} />
        <Skeleton variant="text" width="35%" sx={skeletonBg} />
      </CardContent>
      <CardActions sx={{ px: 2, pb: 2 }}>
        <Skeleton variant="rectangular" width={120} height={32} sx={[skeletonBg, { borderRadius: '2px' }]} />
        <Skeleton variant="rectangular" width={120} height={32} sx={[skeletonBg, { borderRadius: '2px' }]} />
      </CardActions>
    </Card>
  );
}
